import React from 'react';

const StationCell = ({ data, fieldName }) => {
    const station = () => {
        const stations = data[fieldName]?.split(',');
        return stations?.length > 1
            ? 'Multiple (' + stations?.length + ' stations' + ')'
            : stations?.length > 0
            ? stations[0]
            : '-';
    };

    return (
        <div style={{ textAlign: 'left', padding: '0px 10px' }}>
            {station()}
        </div>
    );
};

export default StationCell;
